import filePrepModalHtml from "../product/filePrepModal.hbs";
import { initAccordions } from "../accordion/accordion.js";

class FilePrepModalController {
    constructor (modalInstance, container) {
        this.modalInstance = modalInstance;
        this.container = container;
        this.template = filePrepModalHtml;

        this.render()
    }

    render () {
        this.container.innerHTML = this.template();
        initAccordions(this.container);
    }
}

export default FilePrepModalController;
